/**
 * ProductList - Table component for displaying products
 */

import React, { useMemo } from "react";
import { Tag, Typography, Button, Space } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import DataTable from "../../../shared/components/DataTable";

const { Text } = Typography;

const ProductList = ({
  products = [],
  loading = false,
  onEditProduct,
  onDeleteProduct,
  onRefresh,
}) => {
  const columns = useMemo(
    () => [
      {
        title: "ID",
        dataIndex: "id",
        key: "id",
        width: 150,
        render: (id) => (
          <Text code style={{ fontSize: 12 }}>
            {id}
          </Text>
        ),
      },
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        width: 200,
        render: (name) => (
          <Text strong style={{ fontSize: 14 }}>
            {name || "N/A"}
          </Text>
        ),
      },
      {
        title: "Description",
        dataIndex: "description",
        key: "description",
        width: 250,
        render: (description) => (
          <Text type="secondary" style={{ fontSize: 13 }} ellipsis>
            {description || "N/A"}
          </Text>
        ),
      },
      {
        title: "Price",
        dataIndex: "unitPrice",
        key: "unitPrice",
        width: 120,
        render: (price) => (
          <Text strong style={{ fontSize: 14 }}>
            R {price?.toFixed(2) || "0.00"}
          </Text>
        ),
      },
      {
        title: "Category",
        dataIndex: "category",
        key: "category",
        width: 120,
        render: (category) => {
          const colorMap = {
            supplies: "blue",
            services: "green",
            protection: "orange",
            packing: "purple",
            transport: "cyan",
            other: "default",
          };
          return (
            <Tag color={colorMap[category] || "default"}>
              {category || "other"}
            </Tag>
          );
        },
      },
      {
        title: "Default Supplier",
        dataIndex: "defaultSupplier",
        key: "defaultSupplier",
        width: 150,
        render: (supplier) => (
          <Tag color={supplier === "bubakii" ? "green" : "blue"}>
            {supplier === "bubakii" ? "Bubakii" : supplier || "N/A"}
          </Tag>
        ),
      },
      {
        title: "Status",
        dataIndex: "active",
        key: "active",
        width: 100,
        render: (active) => (
          <Tag color={active ? "success" : "default"}>
            {active ? "Active" : "Inactive"}
          </Tag>
        ),
      },
      {
        title: "SKU",
        dataIndex: "sku",
        key: "sku",
        width: 120,
        render: (sku) => (
          <Text type="secondary" style={{ fontSize: 12 }}>
            {sku || "N/A"}
          </Text>
        ),
      },
      {
        title: "Actions",
        key: "actions",
        width: 150,
        fixed: "right",
        render: (_, record) => (
          <Space size="small">
            <Button
              size="small"
              icon={<EditOutlined />}
              onClick={() => onEditProduct?.(record)}
            >
              Edit
            </Button>
            <Button
              size="small"
              danger
              icon={<DeleteOutlined />}
              onClick={() => onDeleteProduct?.(record)}
            >
              Delete
            </Button>
          </Space>
        ),
      },
    ],
    [onEditProduct, onDeleteProduct]
  );

  return (
    <DataTable
      data={products}
      columns={columns}
      loading={loading}
      title="Products"
      searchPlaceholder="Search products..."
      searchFields={["name", "description", "sku"]}
      onRefresh={onRefresh}
      rowKey="id"
    />
  );
};

export default ProductList;






